import * as WEBPAGE_ACTION from 'constant/action/webpage'
import { handleActions } from 'redux-actions'

const initialState = {
  pagination: {},
  searchTerm: '',
  webpages: {}
}

export default handleActions(
  {
    [WEBPAGE_ACTION.UPDATE_WEBPAGES]: (state, action) => ({
      ...state,
      webpages: action.payload
    }),
    [WEBPAGE_ACTION.UPDATE_WEBPAGE_PAGINATION]: (state, action) => ({
      ...state,
      pagination: action.payload
    }),
    [WEBPAGE_ACTION.UPDATE_WEBPAGE_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    })
  },
  initialState
)
